import {useMutation, gql} from '@apollo/client'

export const MUTATE_UPDATE_CUSTOMIZATIONS = gql`
  mutation MUTATE_DATA($customLabels: [CustomLabels]!) {
    updateCustomizations(customLabels: $customLabels) {
      updateCustomizations {
        permission_id
        is_completed
      }
    }
  }
`

export function useUpdateCustomLabels() {
  return useMutation(MUTATE_UPDATE_CUSTOMIZATIONS, {
    context: {clientName: 'adminPanel'}
  })
}
